import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';

import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Carousel from 'react-material-ui-carousel';
import logo from "../../img/logo.png"





const useStyles = makeStyles((theme) => ({
    root: {
        width: "300px",
        margin: "1%",
        "@media (max-width: 770px)": {
            width: "95%",
            margin: "2%"

        }
    },
    media: {
        height: 0,
        //   paddingTop: '56.25%', // 16:9
        paddingTop: "100%"
        //  width: "100%",
    },
    // expand: {
    //     transform: 'rotate(0deg)',
    //     marginLeft: 'auto',
    //     transition: theme.transitions.create('transform', {
    //         duration: theme.transitions.duration.shortest,
    //     }),
    // },
    // expandOpen: {
    //     transform: 'rotate(180deg)',
    // },
    avatar: {
        backgroundColor: "#f3f3f3",
        "& img": {
            width: "100%",
        }
    },
}));

const Content = ({ title, date, content, image_urls }) => {

    //   console.log(title)
    const classes = useStyles();




    return (<>
        <Card className={classes.root}>

            <CardHeader
                avatar={
                    <Avatar aria-label="recipe" className={classes.avatar}>
                        <img src={logo} alt="logo" />
                    </Avatar>
                }
                action={
                    <IconButton aria-label="settings">
                        <MoreVertIcon />
                    </IconButton>
                }
                title={title}
                subheader={date}
            />

            <Carousel duration={5000} interval={5000} navButtonsAlwaysInvisible={true}>
                {
                    image_urls.map((item, index) => {
                        return <CardMedia image={item} key={index} className={classes.media} />
                    })
                }
            </Carousel>

            <CardActions disableSpacing>
                <IconButton aria-label="add to favorites">
                    <FavoriteIcon />
                </IconButton>
                <IconButton aria-label="share">
                    <ShareIcon />
                </IconButton>
            </CardActions>

        </Card>

    </>
    );
};

export default React.memo(Content);